module.exports = __webpack_public_path__ + "static/img/14.07f9ddc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/4/sp/14.png
// module id = yzns
// module chunks = 0